module.exports = __webpack_public_path__ + "static/img/morentouxiang2.9089316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newstudycenter/morentouxiang2.png
// module id = 6g7o
// module chunks = 311